/**
 * useFindingDetail (P70.2).
 *
 * Wraps GET /v1/findings/{id} via React Query. Backed by the
 * Finding TS interface in shared/api/types -- same shape as the
 * per-entity findings list response.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { Finding } from "shared/api/types";

export const findingDetailKeys = {
  all: ["finding-detail"] as const,
  byId: (id: string) => [...findingDetailKeys.all, id] as const,
};

export function useFindingDetail(
  findingId: string | undefined,
): UseQueryResult<Finding, ApiError> {
  return useQuery({
    queryKey: findingDetailKeys.byId(findingId ?? ""),
    queryFn: () => api.get<Finding>(`/v1/findings/${findingId}`),
    enabled: Boolean(findingId),
    staleTime: 30_000,
  });
}
